import { useNavigate } from "react-router-dom";
import RowMenu from "./RowMenu";
import { useAuth } from "../hooks/useAuth";

/**
 * The account's own actions, next to the status dot at the bottom of the
 * sidebar and the phone drawer.
 *
 * Two items only: everything that used to open a dialog from here now lives on
 * «Налаштування» (2026-09-07). «Вийти» stays because it is one click and
 * moving it behind a page would make leaving harder than it should be.
 */
export default function AccountMenu() {
  const { logout } = useAuth();
  const navigate = useNavigate();

  return (
    <RowMenu
      label="Дії акаунта"
      actions={[
        { label: "Налаштування", onSelect: () => navigate("/settings") },
        { label: "Вийти", danger: true, onSelect: () => void logout() },
      ]}
    />
  );
}
